// extracted by mini-css-extract-plugin
export var categories = "project-profile-module--categories--0a462";
export var categoriesHeadline = "project-profile-module--categoriesHeadline--1a0cd typography-module--base--caba1";
export var grid = "project-profile-module--grid--c4368";
export var gridItemFocus = "project-profile-module--gridItemFocus--bbf99";
export var mainContent = "project-profile-module--mainContent--4f922";
export var mainImage = "project-profile-module--mainImage--15ee8";
export var metaContent = "project-profile-module--metaContent--63fa8";
export var publishedAt = "project-profile-module--publishedAt--01fd1 typography-module--small--089fc";
export var relatedProjects = "project-profile-module--relatedProjects--2bde4";
export var relatedProjectsHeadline = "project-profile-module--relatedProjectsHeadline--26334 typography-module--base--caba1";
export var studentContributor = "project-profile-module--studentContributor--3f13e";
export var studentInfo = "project-profile-module--studentInfo--bffff";
export var studentResumeIcon = "project-profile-module--studentResumeIcon--4ba31";
export var title = "project-profile-module--title--40b8c typography-module--responsiveTitle1--64e79";